import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';

const AttachmentButtonPDF = ({ onFileSelect,acceptType}) => {

const [fileNamePDF, setFileNamePDF] = useState(null);




    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileNamePDF(file.name);
            onFileSelect(file);
            
        }
    };

        return (
            <div>
                <input
                    type="file"
                    id="file-pdf"
                    style={{ display: 'none' }}
                    accept={acceptType}
                    onChange={handleFileSelect}
                />
                <label htmlFor="file-pdf" className="attachment-button mb-3">
                    <FontAwesomeIcon icon={faPaperclip} className="attachment-icon" />
                    {fileNamePDF|| "Adjuntar archivo"}
                </label>
            </div>
        );
    

    
};

export default AttachmentButtonPDF;

